
export const Terms = () => {
  return (
    <div className="leading-relaxed text-[#333] max-w-[900px] mx-auto p-5 bg-white min-h-screen box-border">
      <h1 className="text-[#1890ff] border-b-2 border-[#1890ff] pb-[10px] mt-0 text-[2rem] font-bold">
        SurfingCre Terms of Service / 이용약관
      </h1>
      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        서핑크리(SurfingCre) 서비스 이용약관 — 한국어
      </h2>
      <p className="my-[10px] text-[1.4rem]">
        본 약관은 주식회사 금바다(이하 "회사")가 운영하는 서핑크리 플랫폼 및
        관련 서비스(이하 "서비스")의 이용에 관한 권리·의무 및 책임 사항을
        규정합니다.
      </p>
      <p className="my-[10px] text-[1.4rem]">
        본 약관에 동의하지 않는 경우 서비스 이용이 제한될 수 있습니다.
      </p>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        제1조(목적)
      </h2>
      <p className="my-[10px] text-[1.4rem]">
        이 약관은 회사와 회원 간 서비스 이용에 관한 제반 권리·의무 및 책임사항,
        기타 필요한 사항을 규정함을 목적으로 합니다.
      </p>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        제2조(용어의 정의)
      </h2>
      <ol className="my-[10px] pl-[30px] list-decimal">
        <li className="my-[5px] text-[1.4rem]">
          "서비스"라 함은 회사가 제공하는 브랜드–크리에이터 매칭, 캠페인 관리,
          자동 정산, 데이터 분석 등 플랫폼 관련 모든 서비스를 말합니다.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          "회원"이라 함은 본 약관에 동의하고 서비스에 가입한 개인(크리에이터)
          또는 사업자(브랜드)를 말합니다.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          "브랜드 회원"은 광고주·마케터·기업체 등 캠페인을 의뢰하는 자를
          말합니다.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          "크리에이터 회원"은 콘텐츠를 제작·배포하는 개인 또는 단체를 말합니다.
        </li>
      </ol>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        제3조(약관의 효력 및 변경)
      </h2>
      <ol className="my-[10px] pl-[30px] list-decimal">
        <li className="my-[5px] text-[1.4rem]">
          본 약관은 회원가입 시 동의함으로써 효력이 발생합니다.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          회사는 관련 법령 및 서비스 운영정책에 따라 약관을 변경할 수 있으며,
          변경 시 최소 30일 전 공지합니다(중대한 변경의 경우 개별통지).
        </li>
      </ol>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        제4조(서비스의 제공)
      </h2>
      <ol className="my-[10px] pl-[30px] list-decimal">
        <li className="my-[5px] text-[1.4rem]">
          회사은 다음 서비스를 제공합니다.
          <ul className="my-[10px] pl-[30px] list-disc">
            <li className="my-[5px] text-[1.4rem]">
              가. AI 기반 브랜드–크리에이터 매칭
            </li>
            <li className="my-[5px] text-[1.4rem]">
              나. 캠페인 생성·진행·보고·성과 분석
            </li>
            <li className="my-[5px] text-[1.4rem]">
              다. 전자계약 및 자동 정산 기능
            </li>
            <li className="my-[5px] text-[1.4rem]">
              라. 부가 서비스(교육, 컨설팅 등)
            </li>
          </ul>
        </li>
      </ol>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        제5조(회원의 의무)
      </h2>
      <ol className="my-[10px] pl-[30px] list-decimal">
        <li className="my-[5px] text-[1.4rem]">
          회원은 가입 시 정확한 정보를 제공해야 하며, 허위 사실을 기재해서는 안
          됩니다.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          회원은 타인의 권리를 침해하거나 불법적 활동에 플랫폼을 이용해서는 안
          됩니다.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          캠페인 집행 시 관련 법령(광고법, 표시광고법 등)을 준수해야 합니다.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          위반 시 회사는 서비스 이용 제한, 계약 해지 및 손해배상을 청구할 수
          있습니다.
        </li>
      </ol>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        제6조(회사 의무)
      </h2>
      <ol className="my-[10px] pl-[30px] list-decimal">
        <li className="my-[5px] text-[1.4rem]">
          회사는 안정적인 서비스 제공을 위해 최선의 기술적·관리적 조치를
          취합니다.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          회사는 개인정보 보호법 등 관련 법령을 준수합니다.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          회사는 정당한 사유 없이 서비스를 중단하지 않습니다(단,
          정기점검·불가항력 등 예외 제외).
        </li>
      </ol>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        제7조(지적재산권)
      </h2>
      <ol className="my-[10px] pl-[30px] list-decimal">
        <li className="my-[5px] text-[1.4rem]">
          회원이 등록한 콘텐츠의 저작권은 해당 회원에게 귀속됩니다.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          회사는 서비스 운영을 위해 필요한 범위 내에서 비독점적 이용권을
          가집니다.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          회사가 개발한 알고리즘·데이터·시스템 등은 회사의 자산입니다.
        </li>
      </ol>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        제8조(계약·정산 관련)
      </h2>
      <ol className="my-[10px] pl-[30px] list-decimal">
        <li className="my-[5px] text-[1.4rem]">
          플랫폼 내에서 이루어지는 브랜드와 크리에이터 간 계약은 전자문서로서
          법적 효력을 가집니다.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          정산은 회사의 자동화 시스템을 통해 진행되며, 정산·지급 관련 상세
          정책은 별도의 정산정책에 따릅니다.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          세금 신고·영수증 발급 등 법적 의무 이행을 위해 회원 정보를 사용할 수
          있습니다.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          환불 정책은 다음과 같습니다.
          <ul className="my-[10px] pl-[30px] list-disc">
            <li className="my-[5px] text-[1.4rem]">
              전액 환불 가능: 결제 후 7일 이내이며, 사용 내역이 없는 경우
            </li>
            <li className="my-[5px] text-[1.4rem]">
              부분 환불 불가: 결제 후 7일이 초과되었거나 사용 내역이 있는
              경우. 이 경우 서비스는 이용 만료일까지 정상 유지되며, 만료
              이후 자동 해지됩니다.
            </li>
          </ul>
        </li>
        <li className="my-[5px] text-[1.4rem]">
          "회사"는 결제와 동일한 방법으로 환불을 진행하며, 결제와 동일한
          방법의 환불이 불가능한 때에는 별도의 안내를 제공합니다.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          모든 거래에 대한 책임과 환불, 민원 등의 처리는 회사(금바다)에서
          진행합니다.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          민원담당자: 양은미 (010-3515-5018)
        </li>
      </ol>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        제9조(서비스 이용 제한 및 해지)
      </h2>
      <ol className="my-[10px] pl-[30px] list-decimal">
        <li className="my-[5px] text-[1.4rem]">
          회사는 회원이 본 약관을 위반하거나 서비스 운영을 방해할 경우 이용을
          제한하거나 계약을 해지할 수 있습니다.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          회원은 언제든지 계정 탈퇴를 통해 서비스 이용을 중단할 수 있습니다(탈퇴
          후 일정 기간 관련 데이터가 보관될 수 있음).
        </li>
      </ol>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        제10조(면책조항)
      </h2>
      <ol className="my-[10px] pl-[30px] list-decimal">
        <li className="my-[5px] text-[1.4rem]">
          회사는 회원 간 분쟁(계약 불이행, 지불 문제 등)에 대해 중개자로서
          기본적 지원을 제공하되, 분쟁에 대한 법적 책임은 당사자에게 있습니다.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          천재지변, 전쟁, 네트워크 장애 등 불가항력적 사유로 인한 서비스 중단 및
          손해에 대해 회사는 면책됩니다.
        </li>
      </ol>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        제11조(준거법 및 분쟁해결)
      </h2>
      <p className="my-[10px] text-[1.4rem]">
        본 약관은 대한민국 법령을 준거법으로 하며, 분쟁 발생 시 회사 소재지를
        관할하는 법원을 1심 관할법원으로 합니다.
      </p>

      <p className="my-[10px] text-[1.4rem]">발행일: 2025-11-21</p>

      <h2 className="text-[#333] mt-[50px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        SurfingCre Terms of Service — English
      </h2>

      <p className="my-[10px] text-[1.4rem]">
        These Terms of Service ("Terms") govern the use of the SurfingCre
        platform and related services (the "Service") provided by Geumbada Co.,
        Ltd. ("Company"). By using the Service, you agree to these Terms.
      </p>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        Article 1 (Purpose)
      </h2>
      <p className="my-[10px] text-[1.4rem]">
        These Terms set forth the rights, obligations, and responsibilities of
        the Company and users in connection with the use of the Service.
      </p>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        Article 2 (Definitions)
      </h2>
      <ol className="my-[10px] pl-[30px] list-decimal">
        <li className="my-[5px] text-[1.4rem]">
          "Service" means all platform features provided by the Company,
          including AI-based brand–creator matching, campaign management,
          automated settlement, and data analytics.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          "Member" means an individual creator or a business brand that has
          registered and agreed to these Terms.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          "Brand Member" refers to advertisers, marketers, and businesses
          commissioning campaigns.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          "Creator Member" refers to individuals or teams producing and
          distributing content.
        </li>
      </ol>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        Article 3 (Effect and Changes to the Terms)
      </h2>
      <ol className="my-[10px] pl-[30px] list-decimal">
        <li className="my-[5px] text-[1.4rem]">
          These Terms become effective when a user registers for the Service and
          agrees to them.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          The Company may amend these Terms for legal or operational reasons and
          will notify members at least 30 days prior to significant changes.
        </li>
      </ol>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        Article 4 (Service Provision)
      </h2>
      <ol className="my-[10px] pl-[30px] list-decimal">
        <li className="my-[5px] text-[1.4rem]">
          The Company provides the following services:
          <ul className="my-[10px] pl-[30px] list-disc">
            <li className="my-[5px] text-[1.4rem]">
              a. AI-based brand–creator matching
            </li>
            <li className="my-[5px] text-[1.4rem]">
              b. Campaign creation, execution, reporting, and performance
              analysis
            </li>
            <li className="my-[5px] text-[1.4rem]">
              c. Electronic agreements and automated settlement functions
            </li>
            <li className="my-[5px] text-[1.4rem]">
              d. Additional services such as training and consulting
            </li>
          </ul>
        </li>
      </ol>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        Article 5 (Member Obligations)
      </h2>
      <ol className="my-[10px] pl-[30px] list-decimal">
        <li className="my-[5px] text-[1.4rem]">
          Members must provide accurate information upon registration and must
          not submit false information.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          Members must not use the Service for unlawful activities or infringing
          the rights of others.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          Members must comply with applicable advertising laws when executing
          campaigns.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          Violations may result in restrictions, termination, and claims for
          damages.
        </li>
      </ol>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        Article 6 (Company Obligations)
      </h2>
      <ol className="my-[10px] pl-[30px] list-decimal">
        <li className="my-[5px] text-[1.4rem]">
          The Company will take reasonable technical and managerial measures to
          provide stable service.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          The Company will comply with applicable data protection laws.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          The Company will not arbitrarily suspend service without legitimate
          cause (routine maintenance and force majeure excepted).
        </li>
      </ol>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        Article 7 (Intellectual Property)
      </h2>
      <ol className="my-[10px] pl-[30px] list-decimal">
        <li className="my-[5px] text-[1.4rem]">
          Copyright in content uploaded by Members remains with the Members.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          The Company is granted a non-exclusive license to use such content for
          service operations within the permitted scope.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          The Company's algorithms, data, and systems are company property.
        </li>
      </ol>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        Article 8 (Agreements and Settlement)
      </h2>
      <ol className="my-[10px] pl-[30px] list-decimal">
        <li className="my-[5px] text-[1.4rem]">
          Contracts between Brands and Creators executed via the platform are
          legally binding electronic documents.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          Settlements are processed through the Company's automated system;
          specific settlement policies are provided separately.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          Member information may be used to fulfill tax and legal obligations
          (e.g., invoicing).
        </li>
      </ol>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        Article 9 (Service Suspension and Termination)
      </h2>
      <ol className="my-[10px] pl-[30px] list-decimal">
        <li className="my-[5px] text-[1.4rem]">
          The Company may limit or terminate access for Members who violate
          these Terms or interfere with operation.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          Members may withdraw at any time; however certain data may be retained
          per statutory requirements.
        </li>
      </ol>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        Article 10 (Disclaimer)
      </h2>
      <ol className="my-[10px] pl-[30px] list-decimal">
        <li className="my-[5px] text-[1.4rem]">
          The Company provides mediation and basic support but is not legally
          liable for disputes arising purely between Members.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          The Company is not liable for damages caused by force majeure events
          such as natural disasters, war, or network outages.
        </li>
      </ol>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        Article 11 (Governing Law and Dispute Resolution)
      </h2>
      <p className="my-[10px] text-[1.4rem]">
        These Terms are governed by the laws of the Republic of Korea. Disputes
        shall be resolved in the competent court where the Company is located.
      </p>

      <p className="my-[10px] text-[1.4rem]">Date Issued: 2025-11-21</p>
    </div>
  );
};
